namespace TabAurous.Finance {
    export interface PDCClearanceDetailsRow {
        TransDetailsId?: number;
        TransId?: number;
        RefTransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        LedgerId?: number;
        LedgerName?: string;
        Type?: string;
        AgainstId?: number;
        VoucherTypeId?: number;
        Narration?: string;
        Status?: string;
        ChequeNo?: string;
        ChequeDate?: string;
        Amount?: number;
        CreatedBy?: number;
        FinancialYearId?: number;
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
        CompanyId?: number;
    }

    export namespace PDCClearanceDetailsRow {
        export const idProperty = 'TransDetailsId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.PDCClearanceDetails';
        export const deletePermission = 'Finance:PDCClearance:Delete';
        export const insertPermission = 'Finance:PDCClearance:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:PDCClearance:Edit';

        export declare const enum Fields {
            TransDetailsId = "TransDetailsId",
            TransId = "TransId",
            RefTransId = "RefTransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            Type = "Type",
            AgainstId = "AgainstId",
            VoucherTypeId = "VoucherTypeId",
            Narration = "Narration",
            Status = "Status",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Amount = "Amount",
            CreatedBy = "CreatedBy",
            FinancialYearId = "FinancialYearId",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2",
            CompanyId = "CompanyId"
        }
    }
}
